import { Injectable } from '@angular/core';
import { DelayService } from '../delay/delay.service';
import { DomainProductsDto } from '../httpRequests/domainProductsDto';
import { KeyValueObject } from 'src/app/models/generic/keyValue.model';
import { isUndefined } from 'util';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperationsService {

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  private static toOperationList(products: any): KeyValueObject[] {
    let productsList = new Array<KeyValueObject>();

    for (var i = 0, len = products.length; i < len; i++) {
      let productsDto = new DomainProductsDto(products[i]);
      let domainProductsModel = new KeyValueObject(productsDto.$key, productsDto.$name);
      productsList.push(domainProductsModel);
    };

    return productsList;
  }

  async getSearchOperations(): Promise<Array<string>> {

    const operations: Array<string> = ['Todas'];

    await DelayService.delay(2000);

    return operations;
  }

  async getOperations(): Promise<Array<KeyValueObject>> {
    let ordersList = new Array<KeyValueObject>();

    let body = { "page": 0, "size": 20 };

    try {
      let response = await this.requestHttp(body);
      if (!isUndefined(response)) {
        ordersList = OperationsService.toOperationList(response.elements);
        var pages = response.page;
        if (pages >= 1) {
          for (var i = 1, len = pages; i < len; i++) {
            body.page = i
            response = await this.requestHttp(body);
            ordersList = ordersList.concat(OperationsService.toOperationList(response.elements));
          }
        }
      }

    } catch (error) {
      console.error(error);
    }

    return ordersList;
  }

  private requestHttp(body: any): Promise<any> {
    return this.httpClient.post(`${AppService.configSettings.webApi}/products/`, body).toPromise();
  }

}
